module.exports = __webpack_public_path__ + "static/media/FD3.056056b5.png";